import React from "react";
import { Modal, Button } from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as alertActions from "../../redux/actions/alertConfirmAction";

import { myUtilities } from "../../Utils";

const AlertDialog = (props) => {
    console.log('props', props)
  return (
    <Modal
      show={props.alert.showAlert}
      onHide={props.alertActions.hideConfirmAlertAction}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {myUtilities.accountSpecificLanguage("Alert.Header", "Alert!")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
      {myUtilities.accountSpecificLanguage(
              props.alert.id,
              props.alert.message
       )} {props.alert.custNums}
      </Modal.Body>
      <Modal.Footer>
      <Button variant="primary" onClick={props.onAlertConfirmDialogClick}>{myUtilities.accountSpecificLanguage("AlertDialog.Ok", "Ok")}</Button>
        <Button
          variant="secondary"
          onClick={props.alertActions.hideConfirmAlertAction}
        >
        	{myUtilities.accountSpecificLanguage("AlertDialog.Cancel", "Cancel")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  alert: state.confirmAlert,
});

const mapDispatchToProps = (dispatch) => ({
  alertActions: bindActionCreators(alertActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AlertDialog);
